export default __webpack_public_path__ + "static/media/DIY07.d5e52098.JPG";